'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

exports.aggregateFactory = aggregateFactory;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _sortSortMixin = require('./sort/sortMixin');

var _sortSortMixin2 = _interopRequireDefault(_sortSortMixin);

var _utilsBaseValidator = require('./utils/base-validator');

var _errors = require('./errors');

var _group = require('./group');

var _utilsClone = require('./utils/clone');

var _utilsClone2 = _interopRequireDefault(_utilsClone);

var _sharedTypeUtils = require('./shared/type-utils');

/**
 * @class WixDataAggregate
 * @summary Provides functionality for performing aggregations on collection data.
 * @description
 *  The aggregation functionality of the Data API allows you to perform calculations
 *  on your collection data, as whole or on groups of items that you define, to
 *  retrieve meaningful summaries. You can also add filtering and sorting to your
 *  aggregations to retrieve exactly what you need.
 *
 *  The examples below use a sample collection, named PopulationData, with the following data:
 *
 *  ```
 *  City,          Population, State,  Year
 *  Buffalo,       292000,     NY,     2000
 *  Buffalo,       261000,     NY,     2010
 *  Los Angeles,   3703000,    CA,     2000
 *  Los Angeles,   3796000,    CA,     2010
 *  Miami,         362000,     FL,     2000
 *  Miami,         401000,     FL,     2010
 *  New York,      8015000,    NY,     2000
 *  New York,      8192000,    NY,     2010
 *  Orlando,       195000,     FL,     2000
 *  Orlando,       240000,     FL,     2010
 *  San Diego      1228000,    CA,     2010
 *  San Diego      1306000,    CA,     2012
 *  San Francisco, 777000,     CA,     2000
 *  San Francisco, 805000,     CA,     2010
 *  ```
 *
 *  For more information, see <a href="https://support.wix.com/en/article/working-with-aggregations-and-groupings-in-the-data-api" target="_blank">Working with Aggregations and Groupings in the Data API</a>.
 *
 * @memberof wix-data
 */

var WixDataAggregate = (function (_sortMixin) {
  _inherits(WixDataAggregate, _sortMixin);

  function WixDataAggregate() {
    var obj = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    _classCallCheck(this, WixDataAggregate);

    _get(Object.getPrototypeOf(WixDataAggregate.prototype), 'constructor', this).call(this, obj);
    this.provider = obj.provider;
    this.collectionName = obj.collectionName;
    this.filterTree = obj.filterTree;
    this.havingTree = obj.havingTree;
    this.skipNumber = obj.skipNumber || 0;
    this.limitNumber = obj.limitNumber || 50;
    this.invalidArguments = obj.invalidArguments || [];
  }

  /**
   * @function filter
   * @summary Filters out items from being used in an aggregation.
   * @syntax
   * function filter(filter: WixDataFilter): WixDataAggregate
   * @description
   *  The `filter()` function refines a `WixDataAggregate` so that it only
   *  includes items from the aggregate's collection which match the specified
   *  filter criteria.
   *
   *  To create a filter, use the wix-data [`filter()`](wix-data.html#filter) function.
   *
   *  Filtering using `filter()` takes place before grouping is performed on the
   *  aggregation. To filter grouped results, use the [`having()`](#having) function.
   * @snippet [WixDataAggregate-filter.es6=Filter out items in an aggregation]
   * @snippet [WixDataAggregate-filter_scenario.es6=Filter out items in an aggregation and run the aggregation]
   * @snippet [WixDataAggregate-run_scenario.es6=Create an aggregation with filtering and grouping and run it]
   * @param {wix-data.WixDataFilter} filter The filter to use to filter out items from being used in the aggregation.
   * @returns {wix-data.WixDataAggregate} A `WixDataAggregate` object representing the refined aggregation.
   * @memberof wix-data.WixDataAggregate
   * @instance
   */

  _createClass(WixDataAggregate, [{
    key: 'filter',
    value: function filter(_filter) {
      var _aggregateValidator$arityIsOne$filterIsNotSet$filterBuilder$validateAndAggregate = this._aggregateValidator('.filter').arityIsOne(arguments).filterIsNotSet(this).filterBuilder(_filter).validateAndAggregate();

      var _aggregateValidator$arityIsOne$filterIsNotSet$filterBuilder$validateAndAggregate2 = _slicedToArray(_aggregateValidator$arityIsOne$filterIsNotSet$filterBuilder$validateAndAggregate, 1);

      var newInvalidArguments = _aggregateValidator$arityIsOne$filterIsNotSet$filterBuilder$validateAndAggregate2[0];

      return new WixDataAggregate({
        provider: this.provider,
        collectionName: this.collectionName,
        filterTree: _filter.filterTree,
        groupByTree: this.groupByTree,
        havingTree: this.havingTree,
        skipNumber: this.skipNumber,
        limitNumber: this.limitNumber,
        orderBy: this.orderBy,
        invalidArguments: newInvalidArguments.concat(_filter.invalidArguments)
      });
    }

    /**
     * @function group
     * @summary Groups items together in an aggregation.
     * @syntax
     * function group(...propertyName: string): WixDataAggregate
     * @description
     *  The `group()` function refines a `WixDataAggregate` so that its items are
     *  grouped by the specified property or properties.
     *
     *  You can perform aggregations on the groups using the following functions:
     *
     *  + [`avg()`](#avg)
     *  + [`count()`](#count)
     *  + [`max()`](#max)
     *  + [`min()`](#min)
     *  + [`sum()`](#sum)
     *
     *
     *  To filter grouped results, use the [`having()`](#having) function.
     * @snippet [WixDataAggregate-group.es6=Group items in an aggregation]
     * @snippet [WixDataAggregate-group_multiple.es6=Group items by multiple fields in an aggregation]
     * @snippet [WixDataAggregate-group_scenario.es6=Group items in an aggregation and run the aggregation]
     * @snippet [WixDataAggregate-group_multiple-scenario.es6=Group items in an aggregation and run the aggregation]
     * @snippet [WixDataAggregate-run_scenario.es6=Create an aggregation with filtering and grouping and run it]
     * @param {...external:String} propertyName The property or properties to group on.
     * @returns {wix-data.WixDataAggregate} A `WixDataAggregate` object representing the refined aggregation.
     * @memberof wix-data.WixDataAggregate
     * @instance
     */
  }, {
    key: 'group',
    value: function group() {
      for (var _len = arguments.length, fieldName = Array(_len), _key = 0; _key < _len; _key++) {
        fieldName[_key] = arguments[_key];
      }

      var groupByTree = (0, _utilsClone2['default'])(this.groupByTree);

      var _aggregateValidator$arityIsAtLeastOne$groupIsNotSet$validateAndAggregate = this._aggregateValidator('.group').arityIsAtLeastOne(arguments).groupIsNotSet(groupByTree).validateAndAggregate();

      var _aggregateValidator$arityIsAtLeastOne$groupIsNotSet$validateAndAggregate2 = _slicedToArray(_aggregateValidator$arityIsAtLeastOne$groupIsNotSet$validateAndAggregate, 1);

      var newInvalidArguments = _aggregateValidator$arityIsAtLeastOne$groupIsNotSet$validateAndAggregate2[0];

      if (!groupByTree) {
        groupByTree = { _id: _group.formId.apply(undefined, fieldName) };
      } else if (groupByTree._id === '0') {
        groupByTree = Object.assign({}, groupByTree, { _id: _group.formId.apply(undefined, fieldName) });
      }

      return new WixDataAggregate({
        provider: this.provider,
        collectionName: this.collectionName,
        filterTree: this.filterTree,
        groupByTree: groupByTree,
        havingTree: this.havingTree,
        skipNumber: this.skipNumber,
        limitNumber: this.limitNumber,
        orderBy: this.orderBy,
        invalidArguments: newInvalidArguments
      });
    }

    /**
     * @function having
     * @summary Filters out groups from being returned from an aggregation.
     * @syntax
     * function having(filter: WixDataFilter): WixDataAggregate
     * @description
     *  The `having()` function refines a `WixDataAggregate` so that it only
     *  includes groups from the aggregate's grouping which match the specified
     *  filter criteria.
     *
     *  To create a filter, use the wix-data [`filter()`](wix-data.html#filter) function.
     *
     *  Filtering using `having()` takes place after grouping is performed on the
     *  aggregation. To filter items before grouping, use the [`filter()`](#filter) function.
     * @snippet [WixDataAggregate-having.es6=Filter out groups in an aggregation]
     * @snippet [WixDataAggregate-having_scenario.es6=Filter out groups in an aggregation and run the aggregation]
     * @snippet [WixDataAggregate-run_scenario.es6=Create an aggregation with filtering and grouping and run it]
     * @param {wix-data.WixDataFilter} filter The filter to use to filter out groups from being returned from the aggregation.
     * @returns {wix-data.WixDataAggregate} A `WixDataAggregate` object representing the refined aggregation.
     * @memberof wix-data.WixDataAggregate
     * @instance
     */
  }, {
    key: 'having',
    value: function having(filter) {
      var _aggregateValidator$arityIsOne$havingIsNotSet$filterBuilder$validateAndAggregate = this._aggregateValidator('.having').arityIsOne(arguments).havingIsNotSet(this).filterBuilder(filter).validateAndAggregate();

      var _aggregateValidator$arityIsOne$havingIsNotSet$filterBuilder$validateAndAggregate2 = _slicedToArray(_aggregateValidator$arityIsOne$havingIsNotSet$filterBuilder$validateAndAggregate, 1);

      var newInvalidArguments = _aggregateValidator$arityIsOne$havingIsNotSet$filterBuilder$validateAndAggregate2[0];

      return new WixDataAggregate({
        provider: this.provider,
        collectionName: this.collectionName,
        filterTree: this.filterTree,
        groupByTree: this.groupByTree,
        havingTree: filter.filterTree,
        skipNumber: this.skipNumber,
        limitNumber: this.limitNumber,
        orderBy: this.orderBy,
        invalidArguments: newInvalidArguments.concat(filter.invalidArguments)
      });
    }

    /**
     * @function skip
     * @summary Sets the number of items or groups to skip before returning aggregation results.
     * @syntax
     * function skip(skip: Number): WixDataAggregate
     * @param {external:Number} skip The number of items or groups to skip in the aggregation results before returning the results.
     * @description
     *  The `skip()` function defines the number of results to skip in the aggregation
     *  results before returning new aggregation results.
     *
     *  For example, if you perform an aggregation on a collection and 10 groups match
     *  your aggregation, but you set `skip` to 3, the results returned will skip
     *  the first 3 groups that match and return the 4th through 10th items.
     *
     *  By default, `skip` is set to 0.
     * @snippet [WixDataAggregate-skip.es6=Add a skip to an aggregation]
     * @snippet [WixDataAggregate-skip_scenario.es6=Create an aggregate, add a skip, and run it]
     * @snippet [WixDataAggregate-run_scenario.es6=Create an aggregation with filtering and grouping and run it]
     * @returns {wix-data.WixDataAggregate} A `WixDataAggregate` object representing the refined aggregation.
     * @memberof wix-data.WixDataAggregate
     * @instance
     */
  }, {
    key: 'skip',
    value: function skip(skipNumber) {
      var _aggregateValidator$arityIsOne$isNonNegativeNumber$isInteger$validateAndAggregate = this._aggregateValidator('.skip').arityIsOne(arguments).isNonNegativeNumber(skipNumber).isInteger(skipNumber).validateAndAggregate();

      var _aggregateValidator$arityIsOne$isNonNegativeNumber$isInteger$validateAndAggregate2 = _slicedToArray(_aggregateValidator$arityIsOne$isNonNegativeNumber$isInteger$validateAndAggregate, 1);

      var newInvalidArguments = _aggregateValidator$arityIsOne$isNonNegativeNumber$isInteger$validateAndAggregate2[0];

      return new WixDataAggregate({
        provider: this.provider,
        collectionName: this.collectionName,
        filterTree: this.filterTree,
        groupByTree: this.groupByTree,
        havingTree: this.havingTree,
        skipNumber: skipNumber,
        limitNumber: this.limitNumber,
        orderBy: this.orderBy,
        invalidArguments: newInvalidArguments
      });
    }

    /**
     * @function limit
     * @summary Limits the number of items or groups the aggregation returns.
     * @syntax
     * function limit(limit: Number): WixDataAggregate
     * @param {external:Number} limit The number of items or groups to return.
     * @description
     *  The `limit()` function defines the number of results an aggregation returns in each
     *  page. Only one page of results is retreived at a time. The [`next()`](wix-data.WixDataQueryResult.html)
     *  function is used to navigate the pages of a query result.
     *
     *  By default, `limit` is set to `50`.
     *
     *  The maximum value that `limit()` can accept is `1000`.
     * @snippet [WixDataAggregate-limit.es6=Add a limit to an aggregation]
     * @snippet [WixDataAggregate-limit_scenario.es6=Create an aggregate, add a limit, and run it]
     * @snippet [WixDataAggregate-run_scenario.es6=Create an aggregation with filtering and grouping and run it]
     * @returns {wix-data.WixDataAggregate} A `WixDataAggregate` object representing the refined aggregation.
     * @memberof wix-data.WixDataAggregate
     * @instance
     */
  }, {
    key: 'limit',
    value: function limit(limitNumber) {
      var _aggregateValidator$arityIsOne$isPositiveNumber$isInteger$validateAndAggregate = this._aggregateValidator('.limit').arityIsOne(arguments).isPositiveNumber(limitNumber).isInteger(limitNumber).validateAndAggregate();

      var _aggregateValidator$arityIsOne$isPositiveNumber$isInteger$validateAndAggregate2 = _slicedToArray(_aggregateValidator$arityIsOne$isPositiveNumber$isInteger$validateAndAggregate, 1);

      var newInvalidArguments = _aggregateValidator$arityIsOne$isPositiveNumber$isInteger$validateAndAggregate2[0];

      return new WixDataAggregate({
        provider: this.provider,
        collectionName: this.collectionName,
        filterTree: this.filterTree,
        groupByTree: this.groupByTree,
        havingTree: this.havingTree,
        skipNumber: this.skipNumber,
        limitNumber: limitNumber,
        orderBy: this.orderBy,
        invalidArguments: newInvalidArguments
      });
    }

    /**
     * @function run
     * @summary Runs the aggregation and returns the results.
     * @syntax
     * function run(): Promise<WixDataAggregateResult>
     * @description
     *  The `run()` function returns a Promise that resolves to the results found
     *  by the aggregation and some information about the results.
     * @snippet [WixDataAggregate-run.es6=Perform an aggregation]
     * @snippet [WixDataAggregate-run_scenario.es6=Create an aggregation with filtering and grouping and run it]
     * @returns {external:Promise}
     * @fulfill {wix-data.WixDataAggregateResult} A Promise that resolves to the results of the aggregation.
     * @reject {external:Error} Error that caused the aggregation to fail.
     * @memberof wix-data.WixDataAggregate
     * @instance
     */
  }, {
    key: 'run',
    value: function run() {
      var _this = this;

      var self = this;
      var pipeline = this._buildPipeline();
      return rejectIfInvalid(this.invalidArguments, this.collectionName).then(function () {
        return _this.provider.runAggregate(_this.collectionName, pipeline, _this.limitNumber);
      }).then(function (runResult) {
        return new WixDataAggregateResult({
          items: runResult.items,
          hasNext: runResult.hasNext,
          aggregate: self,
          pageSize: _this.limitNumber
        });
      });
    }

    /**
     * @function max
     * @syntax
     * function max(propertyName: string, [projectedName: string]): WixDataAggregate
     * @summary Refines a `WixDataAggregate` to only contain the maximum value from each aggregation group.
     * @param {external:String} propertyName The property in which to find the maximum value.
     * @param {external:String} [projectedName] The name of the property in the aggregation results containing the maximum value.
     * @returns {wix-data.WixDataAggregate} A `WixDataAggregate` object representing the refined aggregation.
     * @description
     *  The `max()` function refines a `WixDataAggregate` to contain the maximum
     *  value from the specified property for each aggregated group or from the
     *  whole collection if no group is defined.
     *
     *  When the aggregation is [run](#run), the returned `WixDataAggregateResult`
     *  object contains an item for each group with the following key:value pairs:
     *
     *  + If a value was passed for the optional `projectedName`, the key is named
     *    using that value. Otherwise, the key is named using the following format:
     *    `"propertyNameMax"`, where `propertyName` is the name of the specified property.
     *  + The value is the maximum value found in the specified property.
     *
     *
     *  The following types of properties can be compared to determine a maximum value:
     *
     *  + Number: Compares numerically.
     *  + Date and Time: Compares JavaScript Date objects.
     *  + Text: Compares lexicographically, so `"text"` is greater than `"Text"`.
     *  + Rich Text: Compares HTML source as text.
     *  + URL: Compares as text.
     *  + Image: Compares image source as text.
     *  + Video: Compares video source as text.
     *  + Document: Compares document source as text.
     *  + Reference: Compares by the ID of the referenced item as a String.
     * @snippet [WixDataAggregate-max.es6=Add a max aggregation]
     * @snippet [WixDataAggregate-max_projected.es6=Add a max aggregation with a projected name for the results]
     * @snippet [WixDataAggregate-max_scenario.es6=Create an aggregation, add a max aggregation, and run it]
     * @snippet [WixDataAggregate-max_projected-scenario.es6=Create an aggregation, add a max aggregation with a projected name for the results, and run it]
     * @memberof wix-data.WixDataAggregate
     * @instance
     */

    /**
     * @function min
     * @syntax
     * function min(propertyName: string, [projectedName: string]): WixDataAggregate
     * @summary Refines a `WixDataAggregate` to only contain the minimum value from each aggregation group.
     * @param {external:String} propertyName The property in which to find the minimum value.
     * @param {external:String} [projectedName] The name of the property in the aggregation results containing the minimum value.
     * @returns {wix-data.WixDataAggregate} A `WixDataAggregate` object representing the refined aggregation.
     * @description
     *  The `min()` function refines a `WixDataAggregate` to contain the minimum
     *  value from the specified property for each aggregated group or from the
     *  whole collection if no group is defined.
     *
     *  When the aggregation is [run](#run), the returned `WixDataAggregateResult`
     *  object contains an item for each group with the following key:value pairs:
     *
     *  + If a value was passed for the optional `projectedName`, the key is named
     *    using that value. Otherwise, the key is named using the following format:
     *    `"propertyNameMin"`, where `propertyName` is the name of the specified property.
     *  + The value is the minimum value found in the specified property.
     *
     *
     *  The following types of properties can be compared to determine a minimum value:
     *
     *  + Number: Compares numerically.
     *  + Date and Time: Compares JavaScript Date objects.
     *  + Text: Compares lexicographically, so `"text"` is greater than `"Text"`.
     *  + Rich Text: Compares HTML source as text.
     *  + URL: Compares as text.
     *  + Image: Compares image source as text.
     *  + Video: Compares video source as text.
     *  + Document: Compares document source as text.
     *  + Reference: Compares by the ID of the referenced item as a String.
     * @snippet [WixDataAggregate-min.es6=Add a min aggregation]
     * @snippet [WixDataAggregate-min_projected.es6=Add a min aggregation with a projected name for the results]
     * @snippet [WixDataAggregate-min_scenario.es6=Create an aggregation, add a max aggregation, and run it]
     * @snippet [WixDataAggregate-min_projected-scenario.es6=Create an aggregation, add a min aggregation with a projected name for the results, and run it]
     * @memberof wix-data.WixDataAggregate
     * @instance
     */

    /**
     * @function avg
     * @syntax
     * function avg(propertyName: string, [projectedName: string]): WixDataAggregate
     * @summary Refines a `WixDataAggregate` to only contain the average value from each aggregation group.
     * @param {external:String} propertyName The property in which to find the average value.
     * @param {external:String} [projectedName] The name of the property in the aggregation results containing the average value.
     * @returns {wix-data.WixDataAggregate} A `WixDataAggregate` object representing the refined aggregation.
     * @description
     *  The `avg()` function refines a `WixDataAggregate` to contain the average
     *  value from the specified property for each aggregated group or from the
     *  whole collection if no group is defined.
     *
     *  When the aggregation is [run](#run), the returned `WixDataAggregateResult`
     *  object contains an item for each group with the following key:value pairs:
     *
     *  + If a value was passed for the optional `projectedName`, the key is named
     *    using that value. Otherwise, the key is named using the following format:
     *    `"propertyNameAvg"`, where `propertyName` is the name of the specified property.
     *  + The value is the average of the values found in the specified property.
     *
     *
     *  Averages can only be calculated on properties of type Number.
     * @snippet [WixDataAggregate-avg.es6=Add an avg aggregation]
     * @snippet [WixDataAggregate-avg_projected.es6=Add an avg aggregation with a projected name for the results]
     * @snippet [WixDataAggregate-avg_scenario.es6=Create an aggregation, add an avg aggregation, and run it]
     * @snippet [WixDataAggregate-avg_projected-scenario.es6=Create an aggregation, add an avg aggregation with a projected name for the results, and run it]
     * @snippet [WixDataAggregate-avg_scenario-plus.es6=Create an aggregation, add a filter and avg aggregation, and run the aggregation]
     * @memberof wix-data.WixDataAggregate
     * @instance
     */

    /**
     * @function sum
     * @syntax
     * function sum(propertyName: string, [projectedName: string]): WixDataAggregate
     * @summary Refines a `WixDataAggregate` to contain the sum from each aggregation group.
     * @param {external:String} propertyName The property in which to find the sum.
     * @param {external:String} [projectedName] The name of the property in the aggregation results containing the sum.
     * @returns {wix-data.WixDataAggregate} A `WixDataAggregate` object representing the refined aggregation.
     * @description
     *  The `sum()` function refines a `WixDataAggregate` to contain the sum of the
     *  values from the specified property for each aggregated group or from the
     *  whole collection if no group is defined.
     *
     *  When the aggregation is [run](#run), the returned `WixDataAggregateResult`
     *  object contains an item for each group with the following key:value pairs:
     *
     *  + If a value was passed for the optional `projectedName`, the key is named
     *    using that value. Otherwise, the key is named using the following format:
     *    `"propertyNameSum"`, where `propertyName` is the name of the specified property.
     *  + The value is the sum of the values found in the specified property.
     *
     *
     *  Sums can only be calculated on properties of type Number.
     * @snippet [WixDataAggregate-sum.es6=Add a sum aggregation]
     * @snippet [WixDataAggregate-sum_projected.es6=Add a sum aggregation with a projected name for the results]
     * @snippet [WixDataAggregate-sum_scenario.es6=Create an aggregation, add a sum aggregation, and run it]
     * @snippet [WixDataAggregate-sum_projected-scenario.es6=Create an aggregation, add a sum aggregation with a projected name for the results, and run it]
     * @snippet [WixDataAggregate-min_scenario-plus.es6=Create an aggregation, add a filter and sum aggregation, and run the aggregation]
     * @memberof wix-data.WixDataAggregate
     * @instance
     */

    /**
     * @function count
     * @syntax
     * function count(): WixDataAggregate
     * @summary Refines a `WixDataAggregate` to contain the item count of each group in the aggregation.
     * @returns {wix-data.WixDataAggregate} A `WixDataAggregate` object representing the refined aggregation.
     * @description
     *  The `count()` function refines a `WixDataAggregate` to contain the item
     *  count in each of the aggregate's groups.
     *
     *  When the aggregation is [run](#run), the returned `WixDataAggregateResult`
     *  object contains items with the following additional key:value pair:
     *
     *  + The key is named `"count"`.
     *  + The value is the count of items aggregated in the group.
     * @snippet [WixDataAggregate-count.es6=Add a sum aggregation]
     * @snippet [WixDataAggregate-count_scenario.es6=Create an aggregation, add a sum aggregation, and run it]
     * @memberof wix-data.WixDataAggregate
     * @instance
     */

    /**
     * @function ascending
     * @syntax
     * function ascending(...propertyName: String): WixDataAggregate
     * @summary Adds a sort to an aggregation, sorting by the items or groups by the specified properties in ascending order.
     * @param {...external:String} propertyName The properties used in the sort.
     * @returns {wix-data.WixDataAggregate} A `WixDataAggregate` object representing the refined aggregation.
     * @description
     *  The `ascending()` function refines a `WixDataAggregate` to sort the resulting
     *  items or groups in ascending order. If you specify more than one property,
     *  `ascending()` sorts the results in ascending order by each property in the
     *  order they are listed.
     *
     *  You can sort the following types:
     *
     *  + Number: Sorts numerically.
     *  + Date: Sorts by date and time.
     *  + String: Sorts lexicographically, so `"abc"` comes after `"XYZ"`.
     *  + Reference: Compares by the ID of the referenced item as a String.
     *
     *
     *  If a property contains a number as a String, that value will be sorted
     *  alphabetically and not numerically. Items that do not have a value for the
     *  specified sort property are ranked lowest.
     * @snippet [WixDataAggregate-ascending.es6=Add an ascending sort to a query]
     * @snippet [WixDataAggregate-ascending_scenario.es6=Create a query, add an ascending sort, and run it]
     * @memberof wix-data.WixDataAggregate
     * @instance
     */

    /**
     * @function descending
     * @syntax
     * function descending(...propertyName: String): WixDataAggregate
     * @summary Adds a sort to an aggregation, sorting by the items or groups by the specified properties in descending order.
     * @param {...external:String} propertyName The properties used in the sort.
     * @returns {wix-data.WixDataAggregate} A `WixDataAggregate` object representing the refined aggregation.
     * @description
     *  The `descending()` function refines a `WixDataAggregate` to sort the resulting
     *  items or groups in descending order. If you specify more than one property,
     *  `descending()` sorts the results in descending order by each property in the
     *  order they are listed.
     *
     *  You can sort the following types:
     *
     *  + Number: Sorts numerically.
     *  + Date: Sorts by date and time.
     *  + String: Sorts lexicographically, so `"abc"` comes after `"XYZ"`.
     *  + Reference: Compares by the ID of the referenced item as a String.
     *
     *
     *  If a property contains a number as a String, that value will be sorted
     *  alphabetically and not numerically. Items that do not have a value for the
     *  specified sort property are ranked lowest.
     * @snippet [WixDataAggregate-descending.es6=Add a descending sort to a query]
     * @snippet [WixDataAggregate-descending_scenario.es6=Create a query, add a descending sort, and run it]
     * @memberof wix-data.WixDataAggregate
     * @instance
     */

  }, {
    key: '_buildPipeline',
    value: function _buildPipeline() {
      return [this.filterTree ? { $match: this.filterTree } : null, this.groupByTree ? { $group: this.groupByTree } : null, this.groupByTree ? { $project: buildProjectStage(this.groupByTree) } : null, this.havingTree ? { $match: this.havingTree } : null, this.orderBy.length > 0 ? { $sort: this.orderBy } : null, { $skip: this.skipNumber }].filter(function (stage) {
        return stage !== null;
      });
    }
  }, {
    key: '_aggregateValidator',
    value: function _aggregateValidator(operatorName) {
      return new AggregationValidator(operatorName, this.invalidArguments);
    }
  }]);

  return WixDataAggregate;
})((0, _sortSortMixin2['default'])((0, _group.groupMixin)()));

exports.WixDataAggregate = WixDataAggregate;

function rejectIfInvalid(invalidArguments, collectionName) {
  if (invalidArguments.length > 0) {
    return Promise.reject((0, _errors.validationError)(_errors.messages.aggregateInvalid(collectionName, invalidArguments)));
  } else {
    return Promise.resolve();
  }
}

function buildProjectStage(groupByTree) {
  var keys = Object.keys(groupByTree);
  var fields = keys.map(function (key) {
    return _defineProperty({}, key, 1);
  });
  if ((0, _sharedTypeUtils.isObject)(groupByTree._id)) {
    fields.push(projectId(groupByTree._id));
  }
  return Object.assign.apply(Object, [{}].concat(_toConsumableArray(fields)));
}

function projectId(idField) {
  var keys = Object.keys(idField);
  var fields = keys.map(function (key) {
    return _defineProperty({}, key, '$_id.' + key);
  });
  return Object.assign.apply(Object, [{}].concat(_toConsumableArray(fields)));
}

function aggregateFactory(provider, collectionName) {
  return new WixDataAggregate({
    provider: provider,
    collectionName: collectionName,
    skip: 0,
    limit: 50
  });
}

/**
 * @class wix-data.WixDataAggregateResult
 * @summary The results of an aggregation, containing the aggregated values.
 * @classdesc
 *  When you execute an aggregation with the [`run()`](#run) function, it returns
 *  a Promise that resolves to a `WixDataAggregateResult` object, which contains
 *  the aggregated values.
 */

var WixDataAggregateResult = (function () {
  function WixDataAggregateResult(obj) {
    _classCallCheck(this, WixDataAggregateResult);

    if (!obj) {
      return;
    }
    this._items = obj.items;
    this._hasNext = obj.hasNext;
    this._aggregate = obj.aggregate;
    this._pageSize = obj.pageSize;
  }

  /**
   * @member items
   * @summary Gets the aggregated values.
   * @label property
   * @syntax
   * get items(): Object[]
   * @description
   *  The current page of items retrieved by the aggregation.
   *
   *  The page size is defined by the [`limit()`](#limit) function and
   *  navigating through pages is done with the [`next()`](#next) function.
   * @type {external:Object[]} The aggregated values.
   * @memberof wix-data.WixDataAggregateResult
   * @snippet [WixDataAggregateResult-items.es6=Get the aggregate values]
   * @snippet [WixDataAggregateResult-item_scenario.es6=Run an aggregation and get the aggregate values]
   * @instance
   */

  _createClass(WixDataAggregateResult, [{
    key: 'hasNext',

    /**
     * @function hasNext
     * @summary Indicates if the aggregation has more results.
     * @syntax
     * function hasNext(): boolean
     * @returns {external:Boolean} `true` if there are more results.
     * @memberof wix-data.WixDataAggregateResult
     * @snippet [WixDataAggregateResult-hasNext.es6=Get whether the aggregate result object has more results]
     * @snippet [WixDataAggregateResult-hasNext_scenario.es6=Run an aggregation and get whether the aggregate result object has more results]
     * @instance
     */
    value: function hasNext() {
      return this._hasNext;
    }

    /**
     * @member length
     * @summary Returns the number of values in the aggregate results.
     * @syntax
     * get length(): number
     * @type {external:Number} Number of values in the aggregate results.
     * @memberof wix-data.WixDataAggregateResult
     * @snippet [WixDataAggregateResult-length.es6=Get the number of values in the aggregate results]
     * @snippet [WixDataAggregateResult-length_scenario.es6=Run an aggregation and get the number of values in the aggregate results]
     * @instance
     */
  }, {
    key: 'next',

    /**
     * @function next
     * @summary Retrieves the next page of aggregate results.
     * @syntax
     * function next(): Promise<WixDataAggregateResult>
     * @description
     *  The `next()` function retrieves the next page of aggregate results.
     *
     *  The page size is defined by the [`limit()`](#limit) function.
     *
     *  If items are added or removed between calls to `next()` the values returned
     *  by `WixDataAggregateResult` may change.
     * @snippet [WixDataAggregateResult-next.es6=Get the next page of a aggregate result]
     * @returns {external:Promise}
     * @fulfill {wix-data.WixDataAggregateResult} An aggregate object with the next page of aggregate results.
     * @reject {external:Error} The errors that caused the rejection.
     * @memberof wix-data.WixDataAggregateResult
     * @instance
     */
    value: function next() {
      var aggregate = this._aggregate;
      if (this.hasNext()) {
        var newAggregate = aggregate.skip(aggregate.skipNumber + this._pageSize);
        return newAggregate.run();
      }
    }
  }, {
    key: 'items',
    get: function get() {
      return this._items;
    }
  }, {
    key: 'length',
    get: function get() {
      return this._items.length;
    }
  }]);

  return WixDataAggregateResult;
})();

exports.WixDataAggregateResult = WixDataAggregateResult;

var MAX_SAFE_INTEGER = 9007199254740991;

var AggregationValidator = (function (_AggregatingValidator) {
  _inherits(AggregationValidator, _AggregatingValidator);

  function AggregationValidator(operatorName, previousInvalidArguments) {
    _classCallCheck(this, AggregationValidator);

    _get(Object.getPrototypeOf(AggregationValidator.prototype), 'constructor', this).call(this, previousInvalidArguments);
    this.operatorName = operatorName;
  }

  _createClass(AggregationValidator, [{
    key: 'filterBuilder',
    value: function filterBuilder(filter) {
      var _this2 = this;

      return this.addValidation(function () {
        return filter.constructorName === 'FilterBuilder';
      }, function () {
        return _errors.messages.filterMustBeBuilder(_this2.operatorName);
      });
    }
  }, {
    key: 'filterIsNotSet',
    value: function filterIsNotSet(aggregate) {
      var _this3 = this;

      return this.addValidation(function () {
        return aggregate.filterTree === undefined;
      }, function () {
        return _errors.messages.filterIsAlreadySet(_this3.operatorName);
      });
    }
  }, {
    key: 'havingIsNotSet',
    value: function havingIsNotSet(aggregate) {
      var _this4 = this;

      return this.addValidation(function () {
        return aggregate.havingTree === undefined;
      }, function () {
        return _errors.messages.filterIsAlreadySet(_this4.operatorName);
      });
    }
  }, {
    key: 'groupIsNotSet',
    value: function groupIsNotSet(groupByTree) {
      var _this5 = this;

      return this.addValidation(function () {
        return _groupIsNotSet(groupByTree);
      }, function () {
        return _errors.messages.groupIsAlreadySet(_this5.operatorName);
      });
    }
  }, {
    key: '_isNumber',
    value: function _isNumber(specifier, operand) {
      var _this6 = this;

      return this.addValidation(function () {
        return (0, _sharedTypeUtils.isNumber)(operand);
      }, function () {
        return _errors.messages.queryValidations.isNumber(_this6.operatorName, specifier, operand);
      });
    }
  }, {
    key: 'isPositiveNumber',
    value: function isPositiveNumber(operand) {
      var _this7 = this;

      return this._isNumber('positive', operand).addValidation(function () {
        return !Number.isNaN(operand) && operand > 0;
      }, function () {
        return _errors.messages.queryValidations.isPositiveNumber(_this7.operatorName, operand);
      });
    }
  }, {
    key: 'isNonNegativeNumber',
    value: function isNonNegativeNumber(operand) {
      var _this8 = this;

      return this._isNumber('non-negative', operand).addValidation(function () {
        return !Number.isNaN(operand) && operand >= 0;
      }, function () {
        return _errors.messages.queryValidations.isNonNegativeNumber(_this8.operatorName, operand);
      });
    }
  }, {
    key: 'isInteger',
    value: function isInteger(operand) {
      var _this9 = this;

      return this.addValidation(function () {
        return !Number.isNaN(operand) && Number.isFinite(operand) && Number.isInteger(operand) && operand < MAX_SAFE_INTEGER && operand > -MAX_SAFE_INTEGER;
      }, function () {
        return _errors.messages.queryValidations.isInteger(_this9.operatorName, operand);
      });
    }
  }]);

  return AggregationValidator;
})(_utilsBaseValidator.AggregatingValidator);

function _groupIsNotSet(groupByTree) {
  return groupByTree ? groupByTree._id === '0' : true;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-core/lib/aggregate.js
// module id = 177
// module chunks = 0